import React from 'react';
import { Link } from 'react-router-dom';
import Seo from './Seo';
import Header from './Header';
import { useI18n } from '../i18n/I18nContext';
import { EnglishPrivacy } from '../i18n/EnglishLegal';
import './Datenschutz.css';

function Datenschutz() {
  const { lang } = useI18n();
  if (lang === 'en') return <EnglishPrivacy />;

  return (
    <div className="michaela-datenschutz-section">
      <Seo page="datenschutz" />
      <Header />
      <div className="michaela-datenschutz-content">
        <Link to="/" className="michaela-datenschutz-back-link">
          ← Zurück zur Startseite
        </Link>
        <h1 className="michaela-datenschutz-title">
          Datenschutzhinweise für Klientinnen und Klienten
        </h1>
        <p className="michaela-datenschutz-subtitle">
          Coaching, Mediation und Workshops
        </p>
        <p className="michaela-datenschutz-subtitle">
          Informationen nach Art. 13 und 14 der Datenschutz-Grundverordnung (DSGVO), Stand: Oktober 2026
        </p>

        <div className="michaela-datenschutz-text">
          <div className="michaela-datenschutz-block">
            <p>
              Mit diesen Hinweisen informiere ich Sie darüber, welche Daten ich im Rahmen unserer Zusammenarbeit und beim Besuch dieser Website verarbeite, zu welchen Zwecken und welche Rechte Sie haben. Die jeweils aktuelle Fassung finden Sie auch unter michaelabraun.de/datenschutz. Für anwaltliche Mandate gelten gesonderte Datenschutzhinweise meiner Kanzlei.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">1. Verantwortliche</h2>
          <div className="michaela-datenschutz-block">
            <p>
              Prof.in Michaela Braun (im Folgenden „ich“), Kirchenstraße 87b, 81675 München, Deutschland
            </p>
            <p>
              E-Mail: <a href="mailto:mb@michaelabraun.de">mb@michaelabraun.de</a>, Telefon: +49 (0)171 8208818
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">2. Datenschutzbeauftragter</h2>
          <div className="michaela-datenschutz-block">
            <p>
              Eine Pflicht zur Benennung eines Datenschutzbeauftragten besteht nicht (Art. 37 DSGVO, § 38 BDSG). Bei Fragen zum Datenschutz wenden Sie sich bitte unmittelbar an mich unter den oben genannten Kontaktdaten.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading michaela-datenschutz-part">
            Besuch dieser Website – Cookies und Analyse
          </h2>

          <h2 className="michaela-datenschutz-heading">Einwilligungsbanner und Google Analytics</h2>
          <div className="michaela-datenschutz-block">
            <p className="michaela-datenschutz-numbered">
              (1) Beim ersten Besuch fragt ein Banner, ob Sie in die Nutzung von Google Analytics einwilligen. Ihre Entscheidung wird im lokalen Speicher Ihres Browsers abgelegt, damit das Banner nicht bei jedem Seitenaufruf erneut erscheint. Diese Speicherung ist technisch erforderlich (§ 25 Abs. 2 Nr. 2 TDDDG, Art. 6 Abs. 1 lit. f DSGVO).
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Nur wenn Sie einwilligen, nutzt diese Website Google Analytics 4, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Google Analytics setzt Cookies und verarbeitet Informationen über Ihre Nutzung der Website, etwa aufgerufene Seiten, Verweildauer, ungefähren Standort, Gerät und Browser, um mir pseudonyme Auswertungen der Besucherzahlen zu ermöglichen. IP-Adressen werden von Google Analytics 4 nach Angaben von Google nicht gespeichert. Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG).
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) Dabei können Daten an Google LLC in den USA übermittelt werden. Google LLC ist nach dem EU-U.S. Data Privacy Framework zertifiziert; die Übermittlung beruht auf dem Angemessenheitsbeschluss der Europäischen Kommission (Art. 45 DSGVO). Die Analysedaten werden nach höchstens 14 Monaten gelöscht.
            </p>
            <p className="michaela-datenschutz-numbered">
              (4) Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie im Fußbereich jeder Seite auf „Cookie-Einstellungen“ klicken. Das Banner erscheint dann erneut, und Sie können neu entscheiden.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading michaela-datenschutz-part">
            Coaching, Mediation und Workshops
          </h2>

          <h2 className="michaela-datenschutz-heading">3. Welche Daten ich verarbeite</h2>
          <div className="michaela-datenschutz-block">
            <p>
              Im Rahmen von Coaching, Mediation und Workshops verarbeite ich insbesondere folgende Daten:
            </p>
            <p className="michaela-datenschutz-numbered">
              (1) Stammdaten: Anrede, Vor- und Nachname, Anschrift, gegebenenfalls berufliche Funktion und Unternehmen;
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Kontaktdaten: E-Mail-Adresse, Telefonnummern;
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) Inhaltsdaten: Anliegen, Ziele und Inhalte der Sitzungen, die Sie mir anvertrauen, meine Gesprächsnotizen sowie Arbeitsergebnisse und Praxis-Anker;
            </p>
            <p className="michaela-datenschutz-numbered">
              (4) Profildaten: Ergebnisse von Persönlichkeits- und Kommunikationsprofilen (zum Beispiel PCM), sofern Sie ein solches Profil erstellen lassen;
            </p>
            <p className="michaela-datenschutz-numbered">
              (5) Vertrags- und Abrechnungsdaten: Termine, Umfang der Leistungen, Rechnungs- und Zahlungsdaten;
            </p>
            <p className="michaela-datenschutz-numbered">
              (6) Kommunikationsdaten, die bei E-Mail, Telefon und Videokonferenzen anfallen.
            </p>
            <p>
              In Coaching und Mediation können Sie mir auch besonders schützenswerte Informationen anvertrauen, etwa Angaben zu Ihrer Gesundheit oder Ihrem seelischen Befinden (besondere Kategorien personenbezogener Daten nach Art. 9 DSGVO). Diese verarbeite ich nur mit Ihrer ausdrücklichen Einwilligung (Ziffer 4 Abs. 3 und gesondertes Einwilligungsblatt).
            </p>
            <p>
              Die Daten erhebe ich in der Regel bei Ihnen. Wird das Coaching von Ihrem Arbeitgeber oder einem anderen Unternehmen beauftragt, erhalte ich von dort in der Regel Ihren Namen, Ihre Kontaktdaten und gegebenenfalls die vereinbarten Ziele des Coachings (Art. 14 DSGVO). In einer Mediation erhalte ich auch Informationen von den anderen Beteiligten.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">4. Zwecke und Rechtsgrundlagen der Verarbeitung</h2>
          <div className="michaela-datenschutz-block">
            <p className="michaela-datenschutz-numbered">
              (1) Durchführung des Auftrags: Ich verarbeite Ihre Daten, um Coaching, Mediation oder Workshops vorzubereiten und durchzuführen, Termine zu organisieren, mit Ihnen zu kommunizieren und meine Leistungen abzurechnen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Ist nicht Ihre Person, sondern ein Unternehmen mein Vertragspartner, beruht die Verarbeitung Ihrer Daten auf Art. 6 Abs. 1 lit. f DSGVO; mein berechtigtes Interesse liegt in der Durchführung des mit dem Unternehmen geschlossenen Vertrags.
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Gesetzliche Pflichten: Zur Erfüllung steuer- und handelsrechtlicher Aufbewahrungspflichten verarbeite ich Vertrags- und Abrechnungsdaten auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO.
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) Besonders schützenswerte Daten: Gesundheitsdaten und andere besondere Kategorien personenbezogener Daten verarbeite ich nur auf Grundlage Ihrer ausdrücklichen Einwilligung (Art. 9 Abs. 2 lit. a DSGVO), die ich zu Beginn der Zusammenarbeit mit dem beigefügten Einwilligungsblatt einhole. Sie können diese Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
            </p>
            <p className="michaela-datenschutz-numbered">
              (4) Berechtigte Interessen: Zur Durchsetzung meiner Vergütungsansprüche, zur Abwehr von Ansprüchen und zur Gewährleistung der IT-Sicherheit verarbeite ich Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
            </p>
            <p className="michaela-datenschutz-numbered">
              (5) Einwilligung: Soweit Sie mir darüber hinaus eine Einwilligung erteilen, etwa für Fotos in Workshops oder die Aufzeichnung einer Sitzung, ist Rechtsgrundlage Art. 6 Abs. 1 lit. a DSGVO.
            </p>
            <p>
              Die Bereitstellung Ihrer Daten ist für die Durchführung des Auftrags erforderlich. Ohne diese Daten kann ich Coaching, Mediation oder Workshops nicht oder nicht in der vereinbarten Weise erbringen. Eine gesetzliche Pflicht zur Bereitstellung besteht nicht.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">5. Vertraulichkeit</h2>
          <div className="michaela-datenschutz-block">
            <p className="michaela-datenschutz-numbered">
              (1) Alle Inhalte aus Coaching und Mediation behandle ich vertraulich. Als Mediatorin bin ich zudem nach § 4 Mediationsgesetz zur Verschwiegenheit verpflichtet.
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Wird ein Coaching von Ihrem Arbeitgeber oder einem anderen Unternehmen beauftragt, erhält dieses von mir nur die für Organisation und Abrechnung erforderlichen Angaben, insbesondere Termine und Umfang der erbrachten Leistungen. Inhalte aus den Sitzungen gebe ich nur weiter, wenn Sie dem zuvor ausdrücklich zugestimmt haben.
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) In Workshops bitte ich alle Teilnehmenden, persönliche Informationen anderer Teilnehmender vertraulich zu behandeln.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">6. Empfänger Ihrer Daten</h2>
          <div className="michaela-datenschutz-block">
            <p className="michaela-datenschutz-numbered">
              (1) Ich setze sorgfältig ausgewählte Dienstleister ein, insbesondere für IT-Betreuung, E-Mail- und Cloud-Dienste, Videokonferenzen sowie Buchhaltung und Steuerberatung. Dienstleister, die Daten in meinem Auftrag verarbeiten, sind als Auftragsverarbeiter nach Art. 28 DSGVO an meine Weisungen gebunden.
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Für PCM-Profile füllen Sie einen Online-Fragebogen des Lizenzgebers des Process Communication Model® (Kahler Communications) aus. Einzelheiten regelt die gesonderte Einwilligung zum PCM-Profil.
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) Eine Übermittlung in Länder außerhalb der Europäischen Union oder des Europäischen Wirtschaftsraums findet grundsätzlich nicht statt. Soweit eingesetzte Dienstleister, etwa der Anbieter meines Videokonferenzdienstes, Daten in einem Drittland verarbeiten, geschieht dies nur auf Grundlage eines Angemessenheitsbeschlusses der Europäischen Kommission (Art. 45 DSGVO, insbesondere EU-U.S. Data Privacy Framework) oder geeigneter Garantien wie Standardvertragsklauseln (Art. 46 DSGVO).
            </p>
            <p className="michaela-datenschutz-numbered">
              (4) Darüber hinaus gebe ich Ihre Daten nur weiter, wenn ich gesetzlich dazu verpflichtet bin oder Sie eingewilligt haben.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">7. Speicherdauer</h2>
          <div className="michaela-datenschutz-block">
            <p className="michaela-datenschutz-numbered">
              (1) Gesprächsnotizen und sonstige Unterlagen aus Coaching und Mediation bewahre ich bis zum Ablauf der regelmäßigen Verjährungsfrist auf, also drei Jahre ab dem Ende des Kalenderjahres, in dem der Auftrag beendet wurde. Auf Ihren Wunsch lösche ich diese Unterlagen auch früher.
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Rechnungen und sonstige steuer- und handelsrechtlich relevante Unterlagen bewahre ich für die Dauer der gesetzlichen Fristen auf (§ 147 AO, § 257 HGB), derzeit bis zu zehn Jahre.
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) Eine längere Speicherung erfolgt nur, soweit sie zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist oder Sie eingewilligt haben. Nach Ablauf der jeweiligen Frist werden die Daten gelöscht.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">8. Kommunikation per E-Mail und Videokonferenz</h2>
          <div className="michaela-datenschutz-block">
            <p className="michaela-datenschutz-numbered">
              (1) E-Mails versende ich standardmäßig transportverschlüsselt (TLS), soweit der Server des Empfängers dies unterstützt. Die Transportverschlüsselung schützt die Inhalte nicht auf den beteiligten Servern. E-Mails ohne Ende-zu-Ende-Verschlüsselung können daher von Unbefugten zur Kenntnis genommen, verändert oder fehlgeleitet werden. Besonders persönliche Informationen besprechen wir deshalb am besten in der Sitzung selbst. Auf Wunsch vereinbare ich mit Ihnen einen gesicherten Übermittlungsweg.
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Für Online-Sitzungen nutze ich Microsoft Teams (Microsoft Ireland Operations Limited, Dublin) oder Zoom (Zoom Communications, Inc., USA). Dabei werden insbesondere Name, E-Mail-Adresse, Bild- und Tondaten sowie technische Verbindungsdaten verarbeitet. Sitzungen werden nicht aufgezeichnet, es sei denn, Sie haben vorher ausdrücklich eingewilligt.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">9. Automatisierte Entscheidungsfindung</h2>
          <div className="michaela-datenschutz-block">
            <p>
              Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO findet nicht statt. Persönlichkeits- und Kommunikationsprofile dienen ausschließlich der gemeinsamen Arbeit im Coaching.
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">10. Ihre Rechte</h2>
          <div className="michaela-datenschutz-block">
            <p>
              Sie haben nach Maßgabe der gesetzlichen Bestimmungen das Recht,
            </p>
            <p className="michaela-datenschutz-numbered">
              (1) eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO); die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt unberührt;
            </p>
            <p className="michaela-datenschutz-numbered">
              (2) Auskunft über die von mir verarbeiteten personenbezogenen Daten zu verlangen (Art. 15 DSGVO);
            </p>
            <p className="michaela-datenschutz-numbered">
              (3) die Berichtigung unrichtiger oder die Vervollständigung unvollständiger Daten zu verlangen (Art. 16 DSGVO);
            </p>
            <p className="michaela-datenschutz-numbered">
              (4) die Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO), soweit nicht die Verarbeitung insbesondere zur Erfüllung gesetzlicher Aufbewahrungspflichten oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
            </p>
            <p className="michaela-datenschutz-numbered">
              (5) die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO);
            </p>
            <p className="michaela-datenschutz-numbered">
              (6) die Daten, die Sie mir bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder ihre Übermittlung an einen anderen Verantwortlichen zu verlangen (Art. 20 DSGVO);
            </p>
            <p className="michaela-datenschutz-numbered">
              (7) sich bei einer Datenschutzaufsichtsbehörde zu beschweren (Art. 77 DSGVO). Zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach.
            </p>
            <p>
              In einer Mediation kann das Auskunftsrecht eingeschränkt sein, soweit dadurch Informationen anderer Beteiligter offengelegt würden (Art. 15 Abs. 4 DSGVO).
            </p>
          </div>

          <h2 className="michaela-datenschutz-heading">11. Widerspruchsrecht nach Art. 21 DSGVO</h2>
          <div className="michaela-datenschutz-block">
            <p>
              Soweit ich Ihre personenbezogenen Daten auf Grundlage berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO) verarbeite, haben Sie das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit Widerspruch gegen diese Verarbeitung einzulegen. Ich verarbeite Ihre Daten dann nicht mehr, es sei denn, ich kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen. Der Widerspruch ist formfrei und kann an die unter Ziffer 1 genannten Kontaktdaten gerichtet werden.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz;
